var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { verifyPloomesToken } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let PloomesConfigCard = class PloomesConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.token = '';
        this.tokenVerified = false;
        this.ocultedToken = true;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/ploomes-logo.svg';
        this.companyFields = [
            'Razão Social',
            'CEP',
            'CNPJ',
            'Bairro',
            'CNAE Principal',
            'CNAE Secundário',
            'Todos os Emails',
            'Endereço na Web',
            'Url do Facebook',
            'Rua',
            'Dados dos Decisores',
            'Outras Informações',
            'Decisores',
            'Emails Principais',
            'Telefones Principais',
        ];
        this.decisorFields = [
            'Nome',
            'Cargo',
            'Departamento',
            'E-mail',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Todos os planos pagos',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Administrador, Funcionário, Gestor de Equipes, Gestor Geral ou Representante.',
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu lateral esquerdo vai em Clientes e depois em Todas as empresas.',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu lateral esquerdo vai em Clientes e depois em Todos as pessoas.',
            },
            {
                question: 'Onde encontrar os campos customizados?',
                answer: `Na pagina da empresa ou pessoa selecione o icone de engrenagem que 
        fica ao lado das colunas da tabela, vai ser aberto então uma janela chamada 
        "Configurar colunas da tabela", basta selecionar os campos que
        deseja que fiquem visíveis.
        `,
            },
            {
                question: 'Qual o limite de planos customizados?',
                answer: `
        Plano Essencial: 30 /
        Plano Avançado: 100 /
        Plano Profissional: 300 /
        Plano Power: 500 /
        Plano Corporativo: ilimitado
      `,
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá duplicar a empresa e seus contatos',
            },
        ];
    }
    changedOpenModal() {
        this.ocultedToken = true;
    }
    get tutorialVideoLink() {
        return getVideosCRM('ploomes');
    }
    async verifyToken() {
        this.loading = true;
        try {
            await verifyPloomesToken({ token: this.token });
            this.tokenVerified = true;
            this.ocultedToken = true;
            NotificationService.success('Sucesso', 'Seu token foi salvo com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            NotificationService.error('Error', 'O token selecionado está inválido');
        }
        this.loading = false;
    }
    changeToken() {
        this.token = '';
        this.tokenVerified = false;
    }
};
__decorate([
    Watch('openModal')
], PloomesConfigCard.prototype, "changedOpenModal", null);
PloomesConfigCard = __decorate([
    Component({
        name: 'PloomesConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], PloomesConfigCard);
export default PloomesConfigCard;
